import { render, staticRenderFns } from "./DemographicInfoDone.vue?vue&type=template&id=b1a90e8e"
import script from "./DemographicInfoDone.vue?vue&type=script&lang=js"
export * from "./DemographicInfoDone.vue?vue&type=script&lang=js"
import style0 from "./DemographicInfoDone.vue?vue&type=style&index=0&id=b1a90e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports